export const enum CheckMarkColor {
    Pink,
    White,
}
